export default {
	enterOrSpacePressed: (event) => event.keyCode === 13 || event.keyCode === 32,
	enterPressed: (event) => event.keyCode === 13,
	escapePressed: (event) => event.keyCode === 27,
	upArrowPress: (event) => event.keyCode === 38,
	downArrowPress: (event) => event.keyCode === 40,
	shiftEnterPressed: (event) => event.shiftKey && event.keyCode === 13,
	saveIsPressed: (event) => (event.ctrlKey || event.metaKey) && event.keyCode === 83,
};
